import React, { useState } from 'react'
import { Form, Offcanvas, Spinner } from 'react-bootstrap'
import { studyDocumentServices } from '../../../APIServices/studyDocumentServices';

const StudyDocumentoffcanvasData = ({ show, onHide, studyId, getStudyDocument }) => {

  const [fileType, setFileType] = useState('');
  const [file, setFile] = useState(null);
  const [loader, setLoader] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [errorMessage, setErrorMessage] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const validTypes = {
        pdf: 'application/pdf',
        excel: 'application/vnd.ms-excel',
        word: 'application/msword'
      };

      if (selectedFile.type === validTypes[fileType]) {
        setFile(selectedFile);
        setErrorMessage('');
      } else {
        setFile(null);
        setErrorMessage(`Please upload a valid ${fileType} file.`);
      }
    }
  };

  const addStudyDocument = async (e) => {
    e.preventDefault();
    setLoader(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("studyId", studyId);
    formData.append("documentName", documentName);
    formData.append("fileType", fileType);
    await studyDocumentServices.addStudyDocument(formData);
    setLoader(false);
    getStudyDocument();
    clearData()
  };

  const clearData = () => {
    onHide()
    setDocumentName("")
    setFileType("")
  }

  return (
    <>
      <Offcanvas size="md" show={show} onHide={clearData} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Study Document</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-3">
          <Form.Group controlId="formFile" className="mb-2">
            <Form.Label className='fw-bold'>Document Name <abbr title="Required" className='text-danger'>*</abbr></Form.Label>
            <Form.Control
              type="text"
              required
              placeholder="Enter Document Name"
              value={documentName}
              onChange={(e) => setDocumentName(e.target.value)}
            ></Form.Control>
          </Form.Group>


          <Form.Group controlId="formFileType" className="mb-2">
            <Form.Label className='fw-bold'>File Type <abbr title="Required" className='text-danger'>*</abbr></Form.Label>
            <Form.Select onChange={(e) => setFileType(e.target.value)}>
              <option>Select File Type</option>
              <option selected={fileType === "pdf"} value="pdf">PDF</option>
              <option selected={fileType === "pdf"} value="excel">Excel</option>
              <option selected={fileType === "pdf"} value="word">Word</option>
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="formFileUpload" className="mb-2">
            <Form.Label className='fw-bold'>Upload File <abbr title="Required" className='text-danger'>*</abbr></Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
            {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
          </Form.Group>

        </Offcanvas.Body>
        <div className="p-2 text-end border-top bg-light">
          <button className="updateProfile" onClick={addStudyDocument}
            disabled={!documentName || !fileType || !file || loader}
          >
            {loader ? (
              <div className='hstack gap-2'>
                <Spinner size="sm"/> Adding...
              </div>
            ) : (
              "Add Document"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  )
}

export default StudyDocumentoffcanvasData
